let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("8UKe0"), load("8vVzT"), load("ffEVr"), load("bXHUH")]).then(() => parcelRequire('4dpqU'));